import { Pipe, PipeTransform } from '@angular/core';
import { LocaleHelperService } from '@app/services/locale-helper.service';

@Pipe({
  name: 'translateWF',
  standalone: true,
  pure: false,
})
export class TranslateWithFallbackPipe implements PipeTransform {
  constructor(private localeHelperService: LocaleHelperService) {}

  transform(key: string, fallback: string): string {
    return this.localeHelperService.translateWithFallback(key, fallback);
  }
}
